import { render, staticRenderFns } from "./IndicatorBadge.vue?vue&type=template&id=692fdeaa"
import script from "./IndicatorBadge.vue?vue&type=script&lang=js"
export * from "./IndicatorBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports